import React from 'react';
import * as Popover from '@radix-ui/react-popover';

const RadixPopover = ({ 
    children, 
    content, 
    side = "top", 
    align = "center",
    sideOffset = 5,
    alignOffset = 0,
    className = "",
    contentClassName = ""
}) => {
    return (
        <Popover.Root>
            <Popover.Trigger asChild>
                {children}
            </Popover.Trigger>
            <Popover.Portal>
                <Popover.Content
                    side={side}
                    align={align}
                    sideOffset={sideOffset}
                    alignOffset={alignOffset}
                    className={`
                        z-[9999] overflow-hidden rounded-md bg-base-100 shadow-lg 
                        animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out 
                        data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 
                        data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 
                        data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2
                        border border-primary
                        ${contentClassName}
                    `}
                >
                    {content}
                    <Popover.Arrow className="fill-base-100" />
                </Popover.Content>
            </Popover.Portal>
        </Popover.Root>
    );
};

export default RadixPopover; 